import { Drawer } from '@mantine/core';
import classes from './ProfileFieldActionDrawer.module.css';

type Props = {
  children: React.ReactNode;
  opened: boolean;
  onClose: () => void;
};

export const ProfileFieldActionDrawer = ({
  children,
  opened,
  onClose,
}: Props) => {
  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        opened={opened}
        onClose={onClose}
        position="bottom"
        keepMounted={false}
        withCloseButton={false}
        withinPortal={false}
        size="auto">
        {children}
      </Drawer>
    </div>
  );
};
